<template>
  <div>
    <v-row>
       <v-col cols="12" >
         <span>توجه:</span>
         <span>در این فرم می توانید حوزه فعالیت جدید کسب و کارتان را ثبت کنید</span>
         <span>یا اگر در حین ثبت نام یک یا چند حوزه فعالیت از قلم افتاده باشد از این فرم می‌توانید اضافه کنید</span>
         <span> با انتخاب حوزه فعالیت، سیستم به طور خودکار آنرا به ادمین تکصان  ارسال میکند و نیازی به اقدام دیگری نیست.</span>
         <span class="text-bold">منتظر تائید ادمین باشید!</span>
         <HelperComponent helperId="how-to-manage-work-category" class="mt-1 ml-5 float-left text-left" />
       </v-col>
    </v-row>
    <v-row>
     
      <v-col cols="8" class="my-5" v-if="addBtn==false"> 
        <v-btn  color="primary" @click="addBtn = true">افزودن حوزه فعالیت جدید</v-btn>
      </v-col>
      
      <v-col cols="12" md="8" v-if="addBtn">
        <MerchantCategoryTreeSelect
          
          @getData="getData"
          @deleteFromTree="deleteFromTree"
          :listItems="items"
          @addBtn= "addBtn = false"
        />
      </v-col>
    
    </v-row>
    <base-table
      :items="items"
      :headers="headers"
      disable-pagination
      hide-default-footer
    >
      <template v-slot:[`item.createdTimeUtc`]="{ item }">
        {{
          new Date(item.createdTimeUtc).toLocaleDateString('fa-IR', {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
          })
        }}
      </template>
      <template v-slot:[`item.categoryName`]="{ item }">
        <v-btn
          class="mr-n5"
          text
          @click="
            modal = true;
            selected = item;
          "
        >
          {{ item.categoryName }}
        </v-btn>
      </template>
      <template v-slot:[`item.status`]="{ item }">
        {{ item.status == 'Confirmed' ? 'تایید شده' : 'تایید نشده' }}
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon color="error" @click="deleteData(item)"
              ><v-icon v-bind="attrs" v-on="on">mdi-delete</v-icon>
            </v-btn>
          </template>
          <span>حذف</span>
        </v-tooltip>
      </template>
    </base-table>
    <v-dialog v-model="modal" v-if="modal" width="500px">
      <v-card class="pt-6" height="100px">
        <v-card-text>
          <strong class="mb-2">فرآِیند اصلی </strong>
          <br />
          <label>{{ selected.breadcrumb }}</label>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
const categoryRepository = () => RepoFactory.get('category');
import { RepoFactory } from '@/baseRepository/Factory';
import MerchantCategoryTreeSelect from './MerchantCategoryTreeSelect.vue';
import Helper from '@/core/helpers';

export default {
  components: { MerchantCategoryTreeSelect },
  data() {
    return {
      addBtn : false,
      modal: false,
      categoryIds: [],
      items: [],
      headers: [
        {
          value: 'mainCategoryTitle',
          text: 'دسته فرآیند',
          sortable: true,
        },

        {
          value: 'breadcrumb',
          text: 'فرآیند اصلی',
          sortable: false,
        },
 {
          value: 'appliedSupplierProductsCount',
          text: 'کاتالوگ(محصولات،خدمات)',
          sortable: false,
        },

        
        {
          value: 'status',
          text: 'وضعیت',
          sortable: false,
        },
        {
          value: 'actions',
          text: 'عملیات',
        },
      ],
    };
  },
  created() {
    if (this.$store.getters.currentMerchant) {
      this.getData();
    }
  },
  watch: {
    '$store.getters.currentMerchant': function () {
      this.getData();
    },
  },
  computed: {
    baseUrl() {
      return this.$store.getters.productBaseUrl;
    },
  },
  methods: {
    getData() {
      const loader = this.$loading.show();
      categoryRepository()
        .getMerchantCategoriesBreadCrumb(this.baseUrl, {
          MerchantId: this.$store.getters.currentMerchant,
        })
        .then((res) => {
          this.items = res.data;
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
        })
        .finally(() => loader.hide());
    },
    deleteData(item) {
      this.$dialog.warning({
        text: `آیا از حذف اطمینان دارید؟`,
        title: 'هشدار',
        actions: {
          false: {
            color: 'red',
            text: 'خیر',
          },
          true: {
            color: 'primary',
            text: 'بله',
            handle: () => {
              const loader = this.$loading.show();
              categoryRepository()
                .deleteMerchantCategoryById(
                  item.merchantCategoryId,
                  this.baseUrl,
                  { MerchantId: this.$store.getters.currentMerchant }
                )
                .then((res) => {
                  this.$dialog.message.success('با موفقیت حذف گردید', {
                    position: 'top-left',
                  });
                  this.getData();
                })
                .catch((error) => {
                  console.log(error);
                  Helper.handleErrors(error, this);
                })
                .finally(() => loader.hide());
            },
          },
        },
      });
    },
    deleteFromTree(item) {
      const loader = this.$loading.show();
      categoryRepository()
        .deleteMerchantCategoryById(item.merchantCategoryId, this.baseUrl, {
          MerchantId: this.$store.getters.currentMerchant,
        })
        .then((res) => {
          this.$dialog.message.success('با موفقیت حذف گردید', {
            position: 'top-left',
          });
          loader.hide();
          this.getData();
        })
        .catch((error) => {
          loader.hide();
          Helper.handleErrors(error, this);
        })
        .finally(() => loader.hide());
    },
  },
};
</script>

<style></style>
